import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col } from "react-bootstrap";
import { InfoToolTip } from "../../../../components";
export default function CustomPlan() {
  const intl = useIntl();
  return (
    <Col md={4}>
      <div className="subcription-plan-ui" style={{ background: "#fff" }}>
        <h4 className={"title "}>
          Kaspr <FormattedMessage id={"billing.custom"} />
        </h4>
        <p className="subtitle">
          <FormattedMessage id={"billing.custom.forOrganizationsSeeking"} />
        </p>
        <a
          className="btn2"
          target={"_blank"}
          href={"https://kaspr.io/contact/"}
          style={{
            background: "#fff",
            border: "1px solid #3b53d1",
            marginTop: "35px",
          }}
        >
          <FormattedMessage id={"billing.contactUs"} />
        </a>
        <ul className="permissions">
          {[
            intl.formatMessage({ id: "billing.contactSearch" }),
            intl.formatMessage({ id: "billing.contactManagement" }),
            intl.formatMessage({ id: "billing.exportingContact" }),
            intl.formatMessage({ id: "billing.crmIntegration" }),
            intl.formatMessage({ id: "billing.salesAutomation" }),
            intl.formatMessage({ id: "billing.statisticsAndPerformance" }),
            intl.formatMessage({ id: "billing.24x7CustomerSupport" }),
            intl.formatMessage({ id: "billing.teamManagement" }),
            intl.formatMessage({ id: "billing.apiAccess" }),
          ].map((permission, i) => (
            <li key={i}>
              {permission}{" "}
              {permission == "Sales Automation" && (
                <InfoToolTip
                  text={intl.formatMessage({
                    id: "billing.salesAutomationTextInfo",
                  })}
                />
              )}{" "}
            </li>
          ))}
        </ul>
      </div>
    </Col>
  );
}
